import { toast } from 'react-toastify';
import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../Context/AppContext';
import { useAppDispatch, useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import {
  getFavoriteSearch,
  handleResetSearchQuery,
  handleResetSearchQueryError,
  handleResetSortAndFilter,
  updateFavoriteSearch,
  updateSearchResultData,
  getRecentSearch,
  handleSelectedTopCardData,
} from '../../Redux/Reducers/SearchSlice';
import { isEmptyObject } from '../../Utils/Basic';
import { KEYS, SERVER_ERROR_MESSAGES } from '../../Constants/Constants';
import { ELoadCardSize } from '../../Components/Shared/LoadCard/LoadCard.type';
import Breadcrumbs from '../../Components/Shared/Breadcrumbs/Breadcrumbs';
import LoadCard from '../../Components/Shared/LoadCard/LoadCard';
import ResultContainer from '../../Components/ResultContainer/ResultContainer';
import './Results.scss';

const Results = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isMobile } = useContext(AppContext);
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { searchSectionSelectedTab, searchResultData, selectedTopCardData, searchById } =
    useAppSelector((state: RootState) => state?.search);
  const showBanner = useAppSelector((state: RootState) => state.ContentOrConfig?.showBanner);

  useEffect(() => {
    if (isMobile) navigate('/search');
  }, [isMobile, navigate]);

  useEffect(() => {
    if (!selectedTopCardData) navigate('/search');
  }, [navigate, selectedTopCardData]);

  const selectedTab = () => searchSectionSelectedTab?.find((item: any) => item?.selected)?.slug;

  useEffect(() => {
    return () => {
      if (!isEmptyObject(state) && state) {
        dispatch(handleResetSearchQuery());
        dispatch(handleResetSortAndFilter());
      }
      dispatch(handleResetSearchQueryError());

      if (!searchById)
        dispatch(
          updateSearchResultData({
            totalRecords: 0,
            loadPostings: [],
          }),
        );
    };
  }, [dispatch, state, searchById]);

  const handleRightTopButtonClick = (id: string) => {
    const queryPayloads = {
      ...selectedTopCardData,
      favouriteSearchIndicator: !selectedTopCardData?.favouriteSearchIndicator,
    };
    const callback = (res: any) => {
      if (res?.status) {
        const _queryPayloads = {
          page: 0,
          size:
            selectedTab() === 'FavoriteSearch'
              ? KEYS?.FAV_SEARCHES_PAGE_MAX_LOAD_CAPACITY
              : KEYS?.RECENT_SEARCHES_PER_PAGE_MAX_LOAD_CAPACITY,
          sortColumn: 'pickupdate',
          carrierId:
            memberData?.member?.userApplicationDetails?.[0].attributes.CommonCarrierId ?? null,
          userId: memberData?.member?.upn ?? null,
          favorite: selectedTab() === 'FavoriteSearch' ? true : null,
        };
        if (selectedTab() === 'FavoriteSearch') {
          dispatch(getFavoriteSearch(_queryPayloads));
        }
        if (selectedTab() === 'RecentSearch') {
          dispatch(getRecentSearch(_queryPayloads));
        }
        dispatch(
          handleSelectedTopCardData({
            ...selectedTopCardData,
            favouriteSearchIndicator: !selectedTopCardData?.favouriteSearchIndicator,
          }),
        );
      } else {
        toast(res?.errorMessage || SERVER_ERROR_MESSAGES?.generalMsg);
      }
    };
    dispatch(updateFavoriteSearch({ queryPayloads, callback }));
  };

  return (
    <div className={`Results_Container ${showBanner ? ' AlertBannerVisible' : ''}`}>
      <Breadcrumbs selected_Tab={selectedTab() as string} />
      <div className="TopCard_Container">
        <LoadCard
          data={selectedTopCardData}
          isFavorite={selectedTab() === 'FavoriteSearch'}
          isRecent={selectedTab() === 'RecentSearch'}
          isResultsCard={true}
          showBottomButton={false}
          handleRightTopButtonClick={handleRightTopButtonClick}
          size={ELoadCardSize.medium}
          withoutDateTime={true}
          showAdvancedSearchData={true}
        />
      </div>
      {
        <ResultContainer
          additionalClass="Result_Section"
          label="Results"
          totalRecords={searchResultData?.totalRecords}
          loadPostings={searchResultData?.loadPostings}
          isFavorite={selectedTab() === 'FavoriteSearch'}
          isRecent={selectedTab() === 'RecentSearch'}
        />
      }
    </div>
  );
};

export default Results;
